import Swiper from 'swiper';

$(function () {
	//スライダー
	var mainSlider = new Swiper('.slider', {
		loop: true
	});

	//サムネイル
	var Thumbnail = new Swiper('.thumbnail', {
		breakpoints: {
			//SP用
			300: {
				slidesPerView: 4,
				spaceBetween: 5
			},
			//PC用
			500: {
				slidesPerView: 6
			}
		},
		loop: true,
		slideToClickedSlide: true,
	});

	// スライド遷移時にイベントが発生する slideChange というAPIを使用
	// スライダーをスライドした時にサムネイルを移動させる
	mainSlider.on('slideChange', () => {
		// realIndex は現在activeになっているスライドの番号が入っている
		Thumbnail.slideToLoop(mainSlider.realIndex);
	});
	// サムネイルをスライドした時にメインスライドを連動させる(上記と逆)
	Thumbnail.on('slideChange', () => {
		mainSlider.slideToLoop(Thumbnail.realIndex);
	});
});
